import { render, staticRenderFns } from "./loginInfo.vue?vue&type=template&id=c315467c&scoped=true"
import script from "./loginInfo.vue?vue&type=script&lang=js"
export * from "./loginInfo.vue?vue&type=script&lang=js"
import style0 from "./loginInfo.vue?vue&type=style&index=0&id=c315467c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c315467c",
  null
  
)

export default component.exports